export default "__VITE_ASSET__9bd9de45__"